module.exports = __webpack_public_path__ + "img/banner-1.d2944444.png";